import {DOM, JSX} from "/@lib@/commons/xml/dom.js";
import {REG} from "/@lib@/commons/registry.js";
import {
	EOperatorsIn,
	EOperatorsSimple,
	ISearchCrit,
	SearchFullText,
	SearchItemCodeOrTitle,
	SearchItemComment,
	SearchItemLinks,
	SearchItems,
	SearchItemSgnRegexp,
	SearchItemTitleRegexp,
	SearchLastModif,
	SearchLastModifIn,
	SearchLastUser,
	SearchLifeCycleStates,
	SearchOrphan,
	SearchRegexpUri,
	SearchResponsibilities,
	SearchStatus
} from "/@lib@/wsp/search.js";
import {IUiCritArea, OUiCritInit, OUiCritWithInputInit, UiCritArea, UiCritBase, UiCritBool, UiCritFree, UiCritSrcUri, UiCritSubRequest, UiCritUnknown, UiCritXpath} from "/@back@/wsp/widgets/search/uiCrit.js";
import {OItemPointerInit, SrcPointerFastSelect, SrcPointerInline} from "/@back@/wsp/widgets/srcDrawer.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";
import {SpaceSelector} from "/@back@/wsp/dialogs/spaceSelector.js";
import {POPUP} from "/@back@/commons/widgets/popups.js";
import {JSrcFields, SRC, srcRef, srcUri} from "/@lib@/wsp/src.js";
import {Button} from "/@back@/commons/widgets/buttons.js";
import {ITEM} from "/@lib@/wsp/item.js";
import {ItemTypesTree} from "/@back@/wsp/widgets/itemTypesTree.js";
import {UserSelector} from "/@back@/core/dialogs/userSelector.js";
import {EUserAspects, EUserType, JUser, USER} from "/@lib@/core/user.js";
import {LANG} from "/@lib@/commons/lang.js";
import {JTextWedSearchBarParams} from "/@back@/edit/wed/features/searchBar.js";
import {JCommentWedSearchBarParams, JItemWedSearchBarParams} from "/@back@/wsp/widgets/wed/wspSearchBar.js";
import {InputUserPanel, OInputUserInit} from "/@back@/core/widgets/inputs.js";
import {InputPeriod} from "/@back@/core/widgets/inputPeriod.js";
import {ItemType, LC_STATE_DEFAULT_KEY, LC_STATE_DEFAULT_NAME} from "/@lib@/wsp/wspMetaUi.js";
import {OUserRefInit, UserRef} from "/@back@/core/widgets/userRef.js";


// Déclaration des criterions génériques pour la recherche d'items 'wsp.crit.items'.
REG.reg.registerSvc("wsp-uicrit-bool:and", 1, UiCritBool.AREA_AND);
REG.reg.addSvcToList("wsp.crit.items", "wsp-uicrit-bool:and", 1, "wsp-uicrit-bool:and");
REG.reg.registerSvc("wsp-uicrit-bool:or", 1, UiCritBool.AREA_OR);
REG.reg.addSvcToList("wsp.crit.items", "wsp-uicrit-bool:or", 1, "wsp-uicrit-bool:or");
REG.reg.registerSvc("and", 1, UiCritBool.AREA_AND_ROOT);
REG.reg.addSvcToList("wsp.crit.items", "and", 1, "and");
REG.reg.registerSvc("or", 1, UiCritBool.AREA_OR_ROOT);
REG.reg.addSvcToList("wsp.crit.items", "or", 1, "or");
REG.reg.registerSvc("wsp-uicrit-free", 1, UiCritFree.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-uicrit-free", 1, "wsp-uicrit-free");
REG.reg.registerSvc("wsp-uicrit-srcuri-regexp", 1, UiCritSrcUri.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-uicrit-srcuri-regexp", 1, "wsp-uicrit-srcuri-regexp");
REG.reg.registerSvc("wsp-uicrit-xpath", 1, UiCritXpath.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-uicrit-xpath", 1, "wsp-uicrit-xpath");

REG.reg.registerSvc("wsp-uicrit-subrequest:parents", 1, UiCritSubRequest.AREA_PARENTS);
REG.reg.addSvcToList("wsp.crit.items", "wsp-uicrit-subrequest:parents", 1, "wsp-uicrit-subrequest:parents");
REG.reg.registerSvc("wsp-uicrit-subrequest:children", 1, UiCritSubRequest.AREA_CHILDREN);
REG.reg.addSvcToList("wsp.crit.items", "wsp-uicrit-subrequest:children", 1, "wsp-uicrit-subrequest:children");
REG.reg.registerSvc("wsp-uicrit-subrequest:asc", 1, UiCritSubRequest.AREA_ASC);
REG.reg.addSvcToList("wsp.crit.items", "wsp-uicrit-subrequest:asc", 1, "wsp-uicrit-subrequest:asc");
REG.reg.registerSvc("wsp-uicrit-subrequest:desc", 1, UiCritSubRequest.AREA_DESC);
REG.reg.addSvcToList("wsp.crit.items", "wsp-uicrit-subrequest:desc", 1, "wsp-uicrit-subrequest:desc");

REG.reg.registerSvc("exp", 1, UiCritUnknown.AREA);
REG.reg.addSvcToList("wsp.crit.items", "exp", 1, "exp");

/**
 * Scope de recherche par défaut sur tout l'atelier.
 *
 * NOTE : exclusion cachée d'espaces via une pref : ItemCritFullWsp.excludeSpaces
 * Valeur : "/~hidden" ou "/~hidden;/~params"
 */
export class ItemCritFullWsp extends UiCritBase {

	static AREA = new UiCritArea("wsp-itemcrit-fullwsp")
		.setLabel("Tout l'atelier")
		.setCritSgn("scope").setReplacePattern(/\bscope\b/) //.setGroup("scope") pas un critère/filtre
		.setBuildAbstract(function (this: UiCritArea, xml: Element, ctx: OUiCritInit) {
			const air = xml.getAttribute("uiAir") === 'true';
			const foreign = xml.getAttribute("uiForeign") === 'true';
			return <span class="crit">{this.getLabel(ctx) + (air ? foreign ? ", items flottants et étrangers inclus" : ", items flottants inclus" : foreign ? ", items étrangers inclus" : "")}</span>;
		});

	protected _airItems: HTMLInputElement;
	protected _foreignItems: HTMLInputElement;

	get withAirItems(): boolean {return this._airItems ? this._airItems.checked : this.reg.getPref("itemCritFullWsp.withAirItems", false)}

	get withForeignItems(): boolean {return this._foreignItems ? this._foreignItems.checked : this.reg.getPref("itemCritFullWsp.withForeignItems", false)}

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const wsp = this.reg.env.wsp;
		const sr = this.shadowRoot;
		sr.appendChild(<div class="critHead">
			<span class="critTitle">Tout l'atelier</span>
			{this.insertAlternativesBtn(init)}
		</div>);
		let optsRoot = sr as Node;
		if (wsp.isAirItem && wsp.isExtItem) optsRoot = sr.appendChild(<div class="h"/>);
		if (wsp.isAirItem) this._airItems = optsRoot.appendChild(<label class="opt"><input type="checkbox" checked="" onclick={this.onChange}/>Items flottants inclus</label>).firstElementChild as HTMLInputElement;
		if (wsp.isExtItem) this._foreignItems = optsRoot.appendChild(<label class="opt"><input type="checkbox" onclick={this.onChange}/>Items étrangers inclus</label>).firstElementChild as HTMLInputElement;
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		if (this._airItems) this._airItems.checked = xml.getAttribute("uiAir") === 'true';
		if (this._foreignItems) this._foreignItems.checked = xml.getAttribute("uiForeign") === 'true';
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		const crit = new SearchItems().excludeAirItems(!this.withAirItems).excludeExtItems(!this.withForeignItems).includeDrfErased(this.reg.env.wsp.wspDefProps.drfRefWsp != null);
		const fixExclude = this.reg.getPref<string>("ItemCritFullWsp.excludeSpaces"); //Valeur : "/~hidden" ou "/~hidden;/~params"

		if (fixExclude) crit.excludeSpaces(...fixExclude.split(';'));
		return crit;
	}

	buildUiXmlCrit(): Element | undefined {
		const crit = this.buildCrit().toDom();
		crit.setAttribute("uiCrit", this.getUiCritXmlAtt());
		if (this.withAirItems) crit.setAttribute("uiAir", "true");
		if (this.withForeignItems) crit.setAttribute("uiForeign", "true");
		return crit;
	}
}

// REG.reg.registerSkin('wsp-itemcrit-fullWsp', 1, /* language=CSS */ `
// `);

customElements.define("wsp-itemcrit-fullwsp", ItemCritFullWsp);

REG.reg.registerSvc("wsp-itemcrit-fullwsp", 1, ItemCritFullWsp.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-fullwsp", 1, "wsp-itemcrit-fullwsp");


/**
 *
 */
export class UiCritLinksArea extends UiCritArea {

	constructor(public linkAxis: 'LinkAsc' | 'LinkDesc' | 'LinkChildren' | 'LinkParents', protected abstractStrPrefix?: string, public traitsCodeList: string|null = "linktraits:search:defaultList") {
		super("wsp-itemcrit-links");
		this.setReplacePattern(/\bscope\b/);
		this.setCritSgn("scope");
		this.setGroup("scope");
	}

	buildAbstract(xml: Element, ctx: OUiCritInit, options?: any): HTMLElement | undefined {
		if (this.abstractStrPrefix) {
			const srcUri = UiCritLinksArea.makeSrcUriFromLinkExp(xml);
			let result = super.buildAbstract(xml, ctx, options);
			if (srcUri) {
				let srcPointer: SrcPointerInline = <SrcPointerInline î={{
					reg: ctx.reg,
				} as OItemPointerInit}/> as SrcPointerInline;
				Promise.resolve(srcPointer.setSrcRef(srcUri)).then(() => {
					result.innerText = this.abstractStrPrefix;
					result.appendChild(<span class="critVal"/>).appendChild(srcPointer);
					const linkTraitFilter = xml.getAttribute('linkTraitFilter') || "";
					if(linkTraitFilter){
						const traits = ctx.reg.getListAsMap(this.traitsCodeList) as Dict<string> || {};
						result.appendChild(<span>(filtre '{traits[linkTraitFilter] || linkTraitFilter}')</span>)
					}
				});
			}
			return result;
		} else
			return super.buildAbstract(xml, ctx, options);
	}

	setLinkAxis(linkAxis: 'LinkAsc' | 'LinkDesc' | 'LinkChildren' | 'LinkParents'): this {
		this.linkAxis = linkAxis;
		return this;
	}

	/** Extrait un srcUri d'une struture
	 * 		<exp path="" subItemId>
	 * 		OU
	 * 		<exp>
	 *  	 	 <path func="RefUri2Path" sc:refUri="xxxxx"/>
	 *    	 <subItemId func="RefUri2Fragment" sc:refUri="xxxxx"/>
	 *    </exp>
	 */
	static makeSrcUriFromLinkExp(xml: Element): srcRef | null {
		let path = xml?.getAttribute('path');
		let subItemId = xml?.getAttribute('subItemId');
		if (!path && xml?.children) {
			for (const chld of xml.children) {
				if (chld.nodeName === 'path' && chld.getAttribute('func') === 'RefUri2Path')
					path = ITEM.extractSrcRef(chld.getAttribute('sc:refUri'))
				else if (chld.nodeName === 'subItemId' && chld.getAttribute('func') === 'RefUri2Fragment')
					subItemId = ITEM.extractSubItemId(chld.getAttribute('sc:refUri'))
			}
		}
		return ITEM.makeSrcRefSub(path, subItemId);
	}
}

/**
 * Scope de recherche parcourant les liens à partir d'un item.
 */
export class ItemCritLinks extends UiCritBase {

	static AREA_DESC = new UiCritLinksArea("LinkDesc", "Dans le réseau descendant de l'item").setLabel("Réseau descendant d'un item");

	static AREA_ASC = new UiCritLinksArea("LinkAsc", "Dans le réseau ascendant de l'item").setLabel("Réseau ascendant d'un item");

	static AREA_CHILDREN = new UiCritLinksArea("LinkChildren", "Dans les items liés de l'item").setLabel("Items liés par un item");

	static AREA_PARENTS = new UiCritLinksArea("LinkParents", "Dans les items liants l'item").setLabel("Items liant un item")
		.setBuildWedSearch((xml: Element, criterions: Dict<IUiCritArea>): JItemWedSearchBarParams => {
			return {
				searchId: "item",
				findRef: UiCritLinksArea.makeSrcUriFromLinkExp(xml)
			}
		});

	critArea: UiCritLinksArea;

	get linkAxis(): 'LinkAsc' | 'LinkDesc' | 'LinkChildren' | 'LinkParents' {return this.critArea.linkAxis}

	get traitsCodeList():string|null{return this.critArea.traitsCodeList}

	itemPtr: SrcPointerInline;

	trFilter : HTMLSelectElement|null;

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;
		const axis = this.linkAxis;
		this.itemPtr = <SrcPointerInline î={{
			reg: this.reg,
			defaultAction: SrcPointerFastSelect.SINGLETON
		} as OItemPointerInit}/> as SrcPointerInline;

		sr.appendChild(<div class="critHead">
			<span class="critTitle">{axis === 'LinkDesc' ? "Descendants de" : axis === 'LinkAsc' ? "Ascendants de" : axis === 'LinkChildren' ? "Items liés par" : "Items liants"}</span>
			{this.itemPtr}
			{this.insertAlternativesBtn(init)}
		</div>);

		if(this.traitsCodeList){
			const traits = this.reg.getListAsMap(this.traitsCodeList) as Dict<string>;
			if(traits){
				this.trFilter = <select onchange={this.onChange}>
					<option value="" selected>Aucun filtre</option>
				</select> as HTMLSelectElement;
				for (const tr in traits)
					this.trFilter.appendChild(<option value={tr}>{traits[tr]}</option>);
				sr.appendChild(<div class="h">
					{this.trFilter}
				</div>)
			}
		}

		this.itemPtr.onSrcRefChange.add(this.onChange);
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		const srcUri = UiCritLinksArea.makeSrcUriFromLinkExp(xml);
		if (srcUri) {
			await this.itemPtr.setSrcRef(srcUri);
			if (!this.itemPtr.shortDesc?.srcUri || ITEM.getSrcUriType(this.itemPtr.shortDesc.srcUri) != "item")
				this.itemPtr.setSrcRef(null);
		}
		const linkTraitFilter = xml.getAttribute('linkTraitFilter');
		if(linkTraitFilter && this.trFilter)
			this.trFilter.value =linkTraitFilter

		return this;
	}

	async initFromInsAction(xml?: Element): Promise<this> {
		const srcUri = UiCritLinksArea.makeSrcUriFromLinkExp(xml);
		if (srcUri) {
			await this.itemPtr.setSrcRef(srcUri);
			if (!this.itemPtr.shortDesc?.srcUri || ITEM.getSrcUriType(this.itemPtr.shortDesc.srcUri) != "item") {
				this.itemPtr.setSrcRef(null);
				await this.itemPtr.openFastSelect();
			}
		} else if (!this.itemPtr.srcRef) {
			await this.itemPtr.openFastSelect();
		}

		const linkTraitFilter = xml ? xml.getAttribute('linkTraitFilter') : null;
		if(linkTraitFilter && this.trFilter)
			this.trFilter.value =linkTraitFilter

		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		return new SearchItemLinks(this.linkAxis).setRefUri(this.itemPtr.srcRef).setLinkTraitFilter(this.trFilter?.value);
	}

	protected getUiCritXmlAtt(): string {
		return this.linkAxis;
	}

}

REG.reg.registerSkin('wsp-itemcrit-links', 1, /* language=CSS */ `
	wsp-src-pointer-inline {
		flex: 1;
	}
`);

customElements.define("wsp-itemcrit-links", ItemCritLinks);

REG.reg.registerSvc("LinkDesc", 1, ItemCritLinks.AREA_DESC);
REG.reg.addSvcToList("wsp.crit.items", "LinkDesc", 1, "LinkDesc");
REG.reg.registerSvc("LinkAsc", 1, ItemCritLinks.AREA_ASC);
REG.reg.addSvcToList("wsp.crit.items", "LinkAsc", 1, "LinkAsc");
REG.reg.registerSvc("LinkChildren", 1, ItemCritLinks.AREA_CHILDREN);
REG.reg.addSvcToList("wsp.crit.items", "LinkChildren", 1, "LinkChildren");
REG.reg.registerSvc("LinkParents", 1, ItemCritLinks.AREA_PARENTS);
REG.reg.addSvcToList("wsp.crit.items", "LinkParents", 1, "LinkParents");


/**
 * Scope de recherche à partir d'un espace.
 */
export class ItemCritInSpace extends UiCritBase {

	static AREA = new UiCritArea("wsp-itemcrit-inspace").setLabel("Dans un espace").setCritSgn("scope").setGroup("scope").setReplacePattern(/\bscope\b/).setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {
		const path = xml.getAttribute('uiPath') || "";
		return path ? <span class="crit">Dans l'espace '<span class="critVal">{path}</span>'</span> : <span class="crit">Dans un espace</span>;
	});
	//this.setCritSgn("scope");
	//this.setGroup("scope");
	_spaceUri: srcUri;

	get spaceUri(): srcUri {return this._spaceUri};

	set spaceUri(uri: srcUri) {
		this._spaceUri = ITEM.extractSpaceUri(uri);
		this._spaceBtn.label = this.spaceUri || " ";
	}

	protected _spaceBtn: Button;

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;
		sr.appendChild(<div class="critHead">
			<span class="critTitle">Dans l'espace</span>
			{this.insertAlternativesBtn(init)}
		</div>);
		this._spaceBtn = sr.appendChild(<Button id="space" icon={this.reg.env.wsp.wspMetaUi.getSpaceIcon()} onclick={this.onChooseSpace} title="Sélectionner un espace..."/>) as Button;
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		const path = xml.getAttribute('uiPath');
		if (path != null && !SRC.isSrcId(path)) this.spaceUri = path;
		return this;
	}

	async initFromInsAction(xml?: Element): Promise<this> {
		const path = xml ? xml.getAttribute('uiPath') : null;
		if (path != null && !SRC.isSrcId(path)) {
			this.spaceUri = path;
		} else if (!this.spaceUri) {
			await this.onChooseSpace.call(this._spaceBtn);
		}
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		if (this.spaceUri == null) return undefined;
		return new SearchItems().inSpace(this.spaceUri);
	}

	buildUiXmlCrit(): Element | undefined {
		const crit: Element = super.buildUiXmlCrit();
		if (crit && this.spaceUri) crit.setAttribute("uiPath", this.spaceUri);
		return crit;
	}

	async onChooseSpace(this: Button, ev?: Event) {
		const me = DOMSH.findHost(this) as ItemCritInSpace;
		const {SpaceSelector} = await import("/@back@/wsp/dialogs/spaceSelector.js");
		const ct = new SpaceSelector().initialize({
			reg: me.reg,
			startSel: me.spaceUri,
			selOnDblClick: true
		});
		const space = await POPUP.showMenuFromEvent<JSrcFields | null>(ct, ev || me, me).onNextClose();
		if (space) {
			me.spaceUri = space.srcUri;
			me._spaceBtn.label = me.spaceUri;
			me.dispatchChangeEvent();
		}
	}
}

REG.reg.registerSkin('wsp-itemcrit-inspace', 1, /* language=CSS */ `
	#space {
		justify-content: start;
		font-size: 1em;
		/*background-color: var(--form-bgcolor);
		color: var(--form-color);*/
	}
`);

customElements.define("wsp-itemcrit-inspace", ItemCritInSpace);

REG.reg.registerSvc("wsp-itemcrit-inspace", 1, ItemCritInSpace.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-inspace", 1, "wsp-itemcrit-inspace");


/**
 * Recherche full text
 */
export class ItemCritFullText extends UiCritBase {

	static AREA = new UiCritArea("wsp-itemcrit-fulltext").setLabel("Texte")
		.setCritSgn("string").setReplacePattern(/\bstring\b/).setGroup("props").setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {
			const txt = xml.getAttribute("textSearch") || "";
			const opts = xml.getAttribute("options") || "";
			return <span class="crit">Texte contient '<span class="critVal">{txt}</span>'{opts.indexOf(';w;') >= 0 ? ', mot entier' : undefined}{opts.indexOf(';c;') >= 0 ? ', casse respectée' : undefined}</span>;
		}).setBuildWedSearch((xml: Element, criterions: Dict<IUiCritArea>): JTextWedSearchBarParams => {
			const opts = xml.getAttribute("options") || "";
			return {
				searchId: "text",
				text: xml.getAttribute("textSearch") || "",
				wholeWord: opts.indexOf(';w;') >= 0,
				matchCase: opts.indexOf(';c;') >= 0
			}
		});

	protected _text: HTMLInputElement;
	protected _ignoreCase?: HTMLInputElement;
	protected _wholeWord?: HTMLInputElement;

	private conf: OItemCritFullTextInit;

	protected _initialize(init: OItemCritFullTextInit): void {
		this.conf = init;
		super._initialize(init);
		const sr = this.shadowRoot;
		this._text = sr.appendChild(<div class="critHead">
			<span class="critTitle">Texte</span>
			<input type="search" oninput={this.onChange} placeholder={init.placeholder}/>
			{this.insertAlternativesBtn(init)}
		</div>).querySelector("input");
		const optsRoot = sr.appendChild(<div class="h"/>);
		if (init.ignoreCaseInput !== false) this._ignoreCase = optsRoot.appendChild(<label class="opt"><input type="checkbox" onclick={this.onChange} checked={init.ignoreCase}/>Respect de la casse</label>).firstElementChild as HTMLInputElement;
		if (init.wholeWordInput !== false) this._wholeWord = optsRoot.appendChild(<label class="opt"><input type="checkbox" onclick={this.onChange} checked={init.wholeWord}/>Mot entier</label>).firstElementChild as HTMLInputElement;
	}

	private get ignoreCase() {
		return this._ignoreCase ? this._ignoreCase.checked : this.conf.ignoreCase;
	}

	private get wholeWord() {
		return this._wholeWord ? this._wholeWord.checked : this.conf.wholeWord;
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		this._text.value = xml.getAttribute('textSearch') || "";
		const opts = xml.getAttribute('options') || "";
		if (this._ignoreCase) this._ignoreCase.checked = opts.indexOf(';c;') >= 0;
		if (this._wholeWord) this._wholeWord.checked = opts.indexOf(';w;') >= 0;
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		const v = this._text?.value;
		return v ? new SearchFullText(v, this.ignoreCase, this.wholeWord) : undefined;
	}

}

customElements.define("wsp-itemcrit-fulltext", ItemCritFullText);

export interface OItemCritFullTextInit extends OUiCritInit, OUiCritWithInputInit {
	ignoreCase: boolean,/* False par défaut*/
	ignoreCaseInput: boolean,/* true par défaut*/
	wholeWord: boolean,/* False par défaut*/
	wholeWordInput: boolean,/* true par défaut*/
}

REG.reg.registerSvc("wsp-itemcrit-fulltext", 1, ItemCritFullText.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-fulltext", 1, "wsp-itemcrit-fulltext");

/**
 * Code de l'item
 */
export class ItemCritSrcCode extends UiCritBase {

	static AREA = new UiCritArea("wsp-itemcrit-srccode").setLabel("Code de l'item")
		.setCritSgn("string").setReplacePattern(/\bstring\b/).setGroup("props").setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {
			const searchTxt = <span class="critVal">{xml.getAttribute("uiTextSearch") || ""}</span>;
			return <span class="crit">Code de l'item contient '{searchTxt}'</span>;
		});

	protected _textElt: HTMLInputElement;

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;
		this._textElt = sr.appendChild(<div class="critHead">
			<span class="critTitle">Code de l'item</span>
			<input type="search" oninput={this.onChange}/>
			{this.insertAlternativesBtn(init)}
		</div>).querySelector("input");
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		this._textElt.value = xml.getAttribute('uiTextSearch') || "";
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		const v = this._textElt.value;
		if (v) {
			const regexp = new RegExp(".*" + v.replace(/\W/g, LANG.escapeChar4Regexp) + "[^\/]*", "i");
			return new SearchRegexpUri(regexp);
		} else
			return undefined;
	}

	/**
	 * Critères UI :
	 *  - uiTextSearch
	 */
	buildUiXmlCrit(): Element | undefined {
		const crit: Element = super.buildUiXmlCrit();
		if (crit) crit.setAttribute("uiTextSearch", this._textElt.value);
		return crit;
	}

}

customElements.define("wsp-itemcrit-srccode", ItemCritSrcCode);

REG.reg.registerSvc("wsp-itemcrit-srccode", 1, ItemCritSrcCode.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-srccode", 1, "wsp-itemcrit-srccode");

/**
 * Recherche dans le titre
 */
export class ItemCritTitleRegExp extends UiCritBase {

	static AREA = new UiCritArea("wsp-itemcrit-title").setLabel("Titre")
		.setCritSgn("string").setReplacePattern(/\bstring\b/).setGroup("props").setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {
			const searchTxt = <span class="critVal">{xml.getAttribute("uiTextSearch") || xml.getAttribute("regexp")}</span>;
			return <span class="crit">Titre contient '{searchTxt}'</span>;
		});

	protected _textElt: HTMLInputElement;
	protected _regExpElt: HTMLInputElement;

	get isRegExp(): boolean {return this._regExpElt ? this._regExpElt.checked : false}

	protected _initialize(init: OUiCritInit & OUiCritWithInputInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;
		this._textElt = sr.appendChild(<div class="critHead">
			<span class="critTitle">Titre</span>
			<input type="search" oninput={this.onChange} placeholder={init.placeholder}/>
			{this.insertAlternativesBtn(init)}
		</div>).querySelector("input");
		const optsRoot = sr.appendChild(<div class="h"/>);
		this._regExpElt = optsRoot.appendChild(<label class="opt"><input type="checkbox" onclick={this.onChange}/>Expression régulière</label>).firstElementChild as HTMLInputElement;
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		if (xml.hasAttribute('uiTextSearch')) {
			// texte
			this._textElt.value = xml.getAttribute('uiTextSearch') || "";
			this._regExpElt.checked = false;
		} else {
			// regExp
			this._textElt.value = xml.getAttribute('regexp') || "";
			this._regExpElt.checked = true;
		}
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		const v = this._textElt.value;
		if (v && this.isRegExp) {
			return new SearchItemTitleRegexp(new RegExp(v));
		} else if (v) {
			const regexp = new RegExp(".*" + v.replace(/\W/g, LANG.escapeChar4Regexp) + ".*", "i");
			return new SearchItemTitleRegexp(regexp);
		} else
			return undefined;
	}

	buildUiXmlCrit(): Element | undefined {
		const crit: Element = super.buildUiXmlCrit();
		if (crit && !this.isRegExp) crit.setAttribute("uiTextSearch", this._textElt.value);
		return crit;
	}

}

customElements.define("wsp-itemcrit-title", ItemCritTitleRegExp);

REG.reg.registerSvc("wsp-itemcrit-title", 1, ItemCritTitleRegExp.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-title", 1, "wsp-itemcrit-title");



/**
 * Filtre pour rechercher dans le code ou le titre
 * Le critère n'a pas de libellé ni d'options, en vue d'une utilisation dans un panneau de navigation
 */
export class ItemCritCodeOrTitleFilter extends UiCritBase {
	protected _textElt: HTMLInputElement;

	protected _initialize(init: OUiCritInit & OUiCritWithInputInit): void {
		super._initialize(init);
		const placeholder = "placeholder" in init ? init.placeholder : "Filtrer...";
		this._textElt = this.shadowRoot.appendChild(<label id="search">
			<input type="search" oninput={this.onChange} placeholder={placeholder}/>
		</label>).querySelector("input");
	}

	buildCrit(): ISearchCrit | undefined {
		const v = this._textElt.value;
		const regexp = new RegExp(".*" + v.replace(/\W/g, LANG.escapeChar4Regexp) + ".*", "i");
		if (v) return new SearchItemCodeOrTitle(regexp);
		return undefined;
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		this._textElt.value = xml.getAttribute('regexp') || "";
		return this;
	}
}


REG.reg.registerSkin('wsp-itemcrit-codeortitlefilter', 1, /* language=CSS */ `
	:host {
		padding: 0px;
		display: flex;
		min-height: 0;
		min-width: 0;
	}
	
	#search {
		background: 0.1em / 1em no-repeat url(/@skin@/commons/icons/filter.svg) var(--form-search-bgcolor);
		padding-inline-start: 1.2em;
		flex: 1;
	}

	input:focus {
		outline: var(--focus-outline);
		outline-offset: -1px;
	}
	
	input {
		margin: 0;
		padding: 2px;
		border: none;
		width: 100%;
		font-size: inherit;
	}
	
	input::placeholder {
		color: var(--fade-color);
		letter-spacing: 2px;
		font-size: var(--label-size);
		font-style: italic;
	}

	input:focus::placeholder {
		color: transparent;
	}
`);
customElements.define("wsp-itemcrit-codeortitlefilter", ItemCritCodeOrTitleFilter);


/**
 * Items orphelins
 */
export class ItemCritOrphan extends UiCritBase {

	static AREA = new UiCritArea("wsp-itemcrit-orphan").setLabel("Items orphelins").setGroup("item").setCritSgn("noProps").setReplacePattern(/\bnoProps\b/);

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		this.shadowRoot.appendChild(<div class="critHead">
			<span class="critTitle">Items orphelins (référencés par aucun autre item)</span>
			{this.insertAlternativesBtn(init)}
		</div>).querySelector("input");
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		return new SearchOrphan();
	}

}

customElements.define("wsp-itemcrit-orphan", ItemCritOrphan);
REG.reg.registerSvc("wsp-itemcrit-orphan", 1, ItemCritOrphan.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-orphan", 1, "wsp-itemcrit-orphan");


/**
 * Items étrangers
 */
export class ItemCritForeign extends UiCritBase {

	static AREA = new UiCritArea("wsp-itemcrit-foreign").setLabel("Items étrangers").setDescription("Items appartenant à un autre atelier")
		.setGroup("item").setCritSgn("noProps").setReplacePattern(/\bnoProps\b/)
		.setVisible((ctx) => ctx.reg.env.wsp.isExtItem);

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;
		this.shadowRoot.appendChild(<div class="critHead">
			<span class="critTitle">Items étrangers</span>
			{this.insertAlternativesBtn(init)}
		</div>).querySelector("input");
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		return new SearchRegexpUri(new RegExp("^" + LANG.escape4Regexp(ITEM.EXT_PREFIX) + ".*"))
	}
}

customElements.define("wsp-itemcrit-foreign", ItemCritForeign);
REG.reg.registerSvc("wsp-itemcrit-foreign", 1, ItemCritForeign.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-foreign", 1, "wsp-itemcrit-foreign");


/**
 * Items flottants
 */
export class ItemCritAir extends UiCritBase {

	static AREA = new UiCritArea("wsp-itemcrit-air").setLabel("Items flottants")
		.setGroup("item").setCritSgn("noProps").setReplacePattern(/\bnoProps\b/)
		.setVisible((ctx) => ctx.reg.env.wsp.isAirItem);

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;
		this.shadowRoot.appendChild(<div class="critHead">
			<span class="critTitle">Items flottants</span>
			{this.insertAlternativesBtn(init)}
		</div>).querySelector("input");
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		return new SearchRegexpUri(new RegExp("^" + LANG.escape4Regexp(ITEM.AIR_PREFIX) + ".*"))
	}
}

customElements.define("wsp-itemcrit-air", ItemCritAir);
REG.reg.registerSvc("wsp-itemcrit-air", 1, ItemCritAir.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-air", 1, "wsp-itemcrit-air");


/**
 * Statut de l'item
 *    <wsp-itemcrit-status withWarning="false"/>
 */
export class ItemCritStatus extends UiCritBase {

	static STATUS: { [index: string]: any } = {
		//"min-max" : [longLabel, shortLabel]
		"3-3": ["Items en erreur", "en erreur"],
		"2-2": ["Items en alerte", "en alerte"],
		"1-1": ["Items valides", "valides"],
		"2-3": ["Items en erreur ou en alerte", "en erreur ou en alerte"],
		"1-2": ["Items valides ou en alerte", "valides ou en alerte"],
	};

	static AREA = new UiCritArea("wsp-itemcrit-status").setLabel("Statut de l'item")
		.setCritSgn("noProps").setReplacePattern(/\bnoProps\b/).setGroup("item").setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {
			const itemStatusMin = xml.getAttribute("itemStatusMin") || "";
			const itemStatusMax = xml.getAttribute("itemStatusMax") || "";
			return <span class="crit">Statut <span class="critVal">{ItemCritStatus.STATUS[itemStatusMin + "-" + itemStatusMax][1]}</span></span>;
		});

	protected _statusElt: HTMLSelectElement;

	protected _withWarning: Boolean = false;

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);

		this._withWarning = this.hasAttribute("withWarning") ? this.getAttribute("withWarning") == "true" : this.reg.getPref("itemCritStatus.withWarning", false);

		const sr = this.shadowRoot;
		this._statusElt = sr.appendChild(<div class="critHead">
			<span class="critTitle">Statut</span>
			<select onchange={this.onChange}/>
			{this.insertAlternativesBtn(init)}
		</div>).querySelector("select");
		this._statusElt.appendChild(<option value="3-3" selected>{ItemCritStatus.STATUS["3-3"][0]}</option>);
		if (this._withWarning) this._statusElt.appendChild(<option value="2-2">{ItemCritStatus.STATUS["2-2"][0]}</option>);
		this._statusElt.appendChild(<option value="1-1">{ItemCritStatus.STATUS["1-1"][0]}</option>);
		if (this._withWarning) this._statusElt.appendChild(<option value="2-3">{ItemCritStatus.STATUS["2-3"][0]}</option>);
		if (this._withWarning) this._statusElt.appendChild(<option value="1-2">{ItemCritStatus.STATUS["1-2"][0]}</option>);
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		const itemStatusMin: number = Number.parseInt(xml.getAttribute("itemStatusMin")) || 3;
		const itemStatusMax: number = Number.parseInt(xml.getAttribute("itemStatusMax")) || 3;
		this._statusElt.value = itemStatusMin + "-" + itemStatusMax
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		const v = this._statusElt.value.split("-");
		return v ? new SearchStatus(Number.parseInt(v[0]), Number.parseInt(v[1])) : undefined;
	}
}

customElements.define("wsp-itemcrit-status", ItemCritStatus);

REG.reg.registerSvc("wsp-itemcrit-status", 1, ItemCritStatus.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-status", 1, "wsp-itemcrit-status");

/**
 * Date de modification
 *    <wsp-itemcrit-lastmodif/>
 */
export class ItemCritLastModif extends UiCritBase {

	static OPERATORS: { [index: string]: string } = {
		//"op" : [shortLabel]
		"lt": "avant le",
		"gt=": "à partir du",
		"lt=.lt": "le"
	};

	static AREA = new UiCritArea("wsp-itemcrit-lastmodif").setLabel("Date de modification").setDescription("Date de dernière modification")
		.setCritSgn("dateProps").setReplacePattern(/\bdateProps\b/).setGroup("item").setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {
			const options: Intl.DateTimeFormatOptions = {year: 'numeric', month: 'numeric', day: 'numeric'};
			const op = xml.getAttribute("op") || "";
			const date = xml.getAttribute("value") || "";
			const dateObj: Date = new Date(Number.parseInt(date.split(",")[0]))
			const operatorTxt = ItemCritLastModif.OPERATORS[op];
			const dateTxt = <span class="critVal">{dateObj.toLocaleDateString("fr", options)}</span>;
			return <span class="crit">Modifiés {operatorTxt} {dateTxt}</span>;
		});

	protected _opElt: HTMLSelectElement;

	protected _dateElt: HTMLInputElement;

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;

		const critHead = sr.appendChild(<div class="critHead">
			<span class="critTitle">Date de modification</span>
			<select onchange={this.onChange}/>
			<input type="date" onchange={this.onChange}/>
			{this.insertAlternativesBtn(init)}
		</div>);

		this._opElt = critHead.querySelector("select");
		this._opElt.appendChild(<option value="lt" selected>{ItemCritLastModif.OPERATORS["lt"]}</option>);
		this._opElt.appendChild(<option value="gt=" selected>{ItemCritLastModif.OPERATORS["gt="]}</option>);
		this._opElt.appendChild(<option value="lt=.lt" selected>{ItemCritLastModif.OPERATORS["lt=.lt"]}</option>);

		this._dateElt = critHead.querySelector("input");
		this._dateElt.valueAsDate = new Date();
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		const operator = xml.getAttribute("op");
		const value = xml.getAttribute("value");
		this._opElt.value = operator;
		this._dateElt.valueAsDate = new Date(Number.parseInt(value.split(",")[0]));
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		if (this._dateElt.value) {
			if (this._opElt.value == "lt=.lt") {
				const vStart = this._dateElt.valueAsDate;
				const vEnd = new Date(vStart.getFullYear(), vStart.getMonth(), vStart.getDate() + 1);
				return new SearchLastModifIn(this._opElt.value as EOperatorsIn, vStart, vEnd);
			} else
				return new SearchLastModif(this._opElt.value as EOperatorsSimple, this._dateElt.valueAsDate);
		}
		return undefined;
	}
}

customElements.define("wsp-itemcrit-lastmodif", ItemCritLastModif);

REG.reg.registerSvc("wsp-itemcrit-lastmodif", 1, ItemCritLastModif.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-lastmodif", 1, "wsp-itemcrit-lastmodif");

/**
 * Dernier utilisateur à avoir modifié l'item
 *    <wsp-itemcrit-lastuser/>
 */
export class ItemCritLastUser extends UiCritBase {

	static AREA = new UiCritArea("wsp-itemcrit-lastuser").setLabel("Dernière personne à avoir modifié l'item")
		.setCritSgn("userProps").setReplacePattern(/\buserProps\b/).setGroup("item").setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {
			const users = xml.getAttribute('users');
			if (users) {
				let accounts = users.split(" ");
				const usersListVal = <span class="critVal">{accounts.join(", ")}</span>;
				const resulElt = <span class="crit">Modifié par {usersListVal}</span>;
				ctx.reg.env.universe.useUsers.getUserSet(accounts).then(users => {
					if (users) {
						accounts = [];
						const names: string[] = [];
						users.forEach(user => {
							accounts.push(USER.getPrimaryName(user));
							names.push(USER.getLongName(user));
						});
						usersListVal.textContent = accounts.join(", ");
						usersListVal.setAttribute("title", names.join(", "));
					}
				});
				return resulElt;
			}
		}).setVisible((ctx) => {
			return !ctx.reg.env.universe.auth.config.noAuthentication;
		});

	_selectedUsers: JUser[];

	get selectedUsers(): JUser[] {return this._selectedUsers};

	set selectedUsers(users: JUser[]) {
		this._selectedUsers = users;
		this.refreshUi();
	}

	protected _userBtn: Button;

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;
		const critHead = sr.appendChild(<div class="critHead">
			<span class="critTitle">Dernière personne à avoir modifié l'item</span>
			{this.insertAlternativesBtn(init)}
		</div>);
		this._userBtn = sr.appendChild(<Button id="users" onclick={this.onChooseUser} title="Sélectionner un utilisateur..."/>) as Button;
		this.refreshUi();
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		const users = xml.getAttribute('users');
		if (users)
			this.selectedUsers = await this.reg.env.universe.useUsers.getUserSet(users.split(" "));
		return this;
	}

	async initFromInsAction(xml?: Element): Promise<this> {
		await super.initFromInsAction(xml);
		if (!this.selectedUsers || this.selectedUsers.length == 0)
			await this.onChooseUser.call(this._userBtn);
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		if (this.selectedUsers == null) return undefined;
		return new SearchLastUser(this.selectedUsers);
	}

	async onChooseUser(this: Button, ev?: Event) {
		const me = DOMSH.findHost(this) as ItemCritLastUser;
		const {UserSelector} = await import("/@back@/core/dialogs/userSelector.js");
		const userSelector = new UserSelector().initialize({
			reg: me.reg,
			startSel: me.selectedUsers,
			userGrid: {
				usersSrv: me.reg.env.universe.useUsers,
				grid: {
					selType: "multi"
				},
				filterTypeInputVisibility: true,
				filterType: EUserType.user,
				preserveSelectionOnFilter: true,
			},
			selectAndCloseOnDblClick: true
		});
		const user = await POPUP.showMenuFromEvent<JUser[] | null>(userSelector, ev || me, me, null, { initWidth: '20em'}).onNextClose();
		if (user) {
			me.selectedUsers = user;
			me.dispatchChangeEvent();
		}
	}

	private refreshUi(): void {
		while (this._userBtn.lastChild) this._userBtn.removeChild(this._userBtn.lastChild);
		if (this.selectedUsers && this.selectedUsers.length > 0) {
			this.selectedUsers.forEach((user) => {
				this._userBtn.appendChild(<div class="userEntry">
					<img src={USER.getIconUrl(user)}/>
					{USER.getPrimaryName(user)}
				</div>);
			});
		} else
			this._userBtn.appendChild(<div class="noEntry">Veuillez sélectionner des utilisateurs...</div>);
	}
}

REG.reg.registerSkin('wsp-itemcrit-lastuser', 1, /* language=CSS */ `
	c-button {
		align-items: start;
		flex-direction: column;
	}

	#users {
		justify-content: start;
		font-size: 1em;
	}

	.noEntry {
		font-style: italic;
		color: var(--fade-color);
	}

	.userEntry {
		list-style: none;
		display: list-item;
		margin-inline-start: 1em;
	}

	.userEntry > img {
		height: 1em;
		margin-inline-end: .5em;
	}
`);

customElements.define("wsp-itemcrit-lastuser", ItemCritLastUser);

REG.reg.registerSvc("wsp-itemcrit-lastuser", 1, ItemCritLastUser.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-lastuser", 1, "wsp-itemcrit-lastuser");


/**
 * Type de l'item (class)
 *    <wsp-itemcrit-type/>
 *    Possibilité de filter la liste des itemTypes proposés via
 *    	- la propriété 'itemTypeReducer'
 *    	- ou, à défaut, le svc du registre `itemCritType.itemTypeReducer`
 */
export class ItemCritType extends UiCritBase {

	static AREA = new UiCritArea("wsp-itemcrit-type").setLabel("Type de l'item")
		.setGroup("item").setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {
			const itModels = xml ? xml.getAttribute('uiItModels') : null;
			const itLabels: string[] = [];
			if (itModels != null) {
				const itTypesArray = itModels.split("|");
				itTypesArray.forEach(itModel => {
					itLabels.push(ctx.reg.env.wsp.wspMetaUi.getItemType(itModel).getTitle());
				});
			}
			if (itLabels.length == 1) {
				const itLabel = <span class="critVal">{itLabels[0]}</span>;
				return <span class="crit">Type '{itLabel}'</span>;
			} else {
				const itCount = <span class="critVal">{itLabels.length}</span>;
				return <span class="crit" title={itLabels.join(", ")}>{itCount} types</span>;
			}
		});

	/** Reducer des itemType proposés*/
	public itemTypeReducer : (acc: ItemType[], cur: ItemType, idx?: number, src?: ItemType[]) => ItemType[] = null;

	/** Contient la sélection courante */
	protected _selectedItModels: string[];

	protected _itemTypesPopup: HTMLElement;

	/** Utilisé uniquement pour l'affichage  */
	protected _itemTypesTree: ItemTypesTree;

	protected _itemsBtn: Button;

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;

		sr.appendChild(<div class="critHead">
			<span class="critTitle">Type(s) :</span>
			{this.insertAlternativesBtn(init)}
		</div>);

		// Popup de sélection
		//let template = sr.appendChild(<template/>);
		this._itemTypesPopup = <div id="root"/>;
		this._itemTypesPopup.attachShadow(DOMSH.SHADOWDOM_INIT);
		this.reg.installSkin("wsp-itemcrit-type/selector", this._itemTypesPopup.shadowRoot);

		const itemTypeReducer = this.itemTypeReducer || this.reg.getSvc("itemCritType.itemTypeReducer");

		this._itemTypesTree = this._itemTypesPopup.shadowRoot.appendChild(new ItemTypesTree().initialize({
			reg: this.reg,
			textFilter: "",
			itemTypeReducer,
			forbidHideSelectedRow: true,
			grid: {
				selType: "multi"
			}
		}));
		this._itemTypesTree.setAttribute("style", "max-height: 20em;");
		const footer = this._itemTypesPopup.shadowRoot.appendChild(<div id="footer">
			<div id="msg"/>
		</div>);
		footer.appendChild(<Button id="select" label="Sélectionner" ui-context="dialog" onclick={this.chooseItems_onSelectBtn.bind(this)}/>);
		footer.appendChild(<Button id="cancel" label="Annuler" ui-context="dialog" onclick={this.chooseItems_onCancelBtn.bind(this)}/>);

		// Btn
		this._itemsBtn = sr.appendChild(<Button id="itemsTypes" label=" " onclick={this.onChooseItems} title="Sélectionner des types d'item..."/>) as Button;

		this.redraw();
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		const itTypes = xml ? xml.getAttribute('uiItModels') : null;
		this._selectedItModels = itTypes?.split("|");
		this.redraw();
		return this;
	}

	async initFromInsAction(xml?: Element): Promise<this> {
		await super.initFromInsAction(xml);
		// Affichage auto du popup sur la création
		if (!this._selectedItModels || this._selectedItModels.length == 0)
			await this.onChooseItems.call(this._itemsBtn);
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		if (!this._selectedItModels || this._selectedItModels.length == 0) return undefined;
		// @see morphologie signature Wui_Modeling\doc\class\signature.md
		return new SearchItemSgnRegexp(this._selectedItModels?.map(entry => '.*@' + LANG.escape4Regexp(entry) + "\\b.*"));
	}

	/**
	 *  Critères UI :
	 *    uiItModels : liste des itModels sélectionnés, sépapés par un |
	 */
	buildUiXmlCrit(): Element | undefined {
		const itModels: string[] = [];
		const crit: Element = super.buildUiXmlCrit();
		if (crit && this._selectedItModels) crit.setAttribute("uiItModels", this._selectedItModels.join("|"));
		return crit;
	}

	/**
	 * Redraw UI
	 *    Mémorisation des sélctions dans "_itemTypesTree"
	 */
	private redraw(): void {
		while (this._itemsBtn.firstChild) this._itemsBtn.removeChild(this._itemsBtn.firstChild);
		if (this._selectedItModels && this._selectedItModels.length > 0) {
			this._selectedItModels.forEach(itModel => {
				const itemType = this.reg.env.wsp.wspMetaUi.getItemType(itModel);
				if (itemType) {
					this._itemsBtn.appendChild(<div class="modelEntry">
						<img src={itemType.getIcon()}/>
						{itemType.getTitle()}
					</div>);
				}
			});
		} else
			this._itemsBtn.appendChild(<div class="noEntry">Veuillez sélectionner des types d'item...</div>);
	}

	async onChooseItems(this: Button, ev?: Event) {
		const me = DOMSH.findHost(this) as ItemCritType;
		me._itemTypesTree.clearSearch();
		me._itemTypesTree.selectByItModels(me._selectedItModels);
		await POPUP.showMenuFromEvent(me._itemTypesPopup, ev || me, me, {skinOver: "wsp-itemcrit-type-popup"}).onNextClose();
	}

	chooseItems_onCancelBtn(this: ItemCritType) {
		POPUP.findPopupableParent(this._itemTypesPopup).close();
	}

	chooseItems_onSelectBtn(this: ItemCritType) {
		this._selectedItModels = [];
		this._itemTypesTree.getSelectedItemsTypes().forEach(itemType => {
			this._selectedItModels.push(itemType.getModel());
		});
		this.dispatchChangeEvent();
		this.redraw();
		POPUP.findPopupableParent(this._itemTypesPopup).close();
	}

}

customElements.define("wsp-itemcrit-type", ItemCritType);
REG.reg.registerSkin('wsp-itemcrit-type', 1, /* language=CSS */ `
	c-button {
		align-items: start;
		flex-direction: column;
	}

	.noEntry {
		font-style: italic;
		color: var(--fade-color);
	}

	.modelEntry {
		list-style: none;
		display: list-item;
		margin-inline-start: 1em;
	}
`);
REG.reg.registerSkin('wsp-itemcrit-type/selector', 1, /* language=CSS */ `
	wsp-itemtypes-tree {
		max-height: 20em;
	}

	#footer {
		border-top: 1px solid var(--border-color);
		display: flex;
		min-height: 0;
		min-width: 0;
		align-items: center;
	}

	#msg {
		flex: 1;
	}
`);

REG.reg.registerSvc("wsp-itemcrit-type", 1, ItemCritType.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-type", 1, "wsp-itemcrit-type");


/**
 * Item commenté
 *    <wsp-itemcrit-comment/>
 */
export class ItemCritComment extends UiCritBase {

	static AREA = new UiCritArea("wsp-itemcrit-comment").setLabel("Item commenté")
		.setGroup("props").setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {
			let msg = "";
			if (xml.hasAttribute("uiIncludeClosed") && (xml.hasAttribute("uiIncludeOpen")))
				msg = "Commentaires ouverts ou clos";
			else if (xml.hasAttribute("uiIncludeClosed"))
				msg = "Commentaires clos";
			else
				msg = "Commentaires ouverts";
			return <span class="crit" title={msg}>Item commenté</span>;
		}).setBuildWedSearch((xml: Element, criterions: Dict<IUiCritArea>): JCommentWedSearchBarParams => {
			return {
				searchId: "comment",
				opened: xml.hasAttribute("uiIncludeOpen"),
				closed: xml.hasAttribute("uiIncludeClosed")
			}
		});

	protected opened: HTMLInputElement;

	protected closed: HTMLInputElement;

	get withOpenComments(): boolean {return this.opened ? this.opened.checked : false}

	get withClosedComments(): boolean {return this.closed ? this.closed.checked : false}

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;

		const critHead = sr.appendChild(<div class="critHead">
			<span class="critTitle">Item commenté</span>
			{this.insertAlternativesBtn(init)}
		</div>);

		this.opened = critHead.appendChild(<label class="opt"><input type="checkbox" checked="" onclick={this.onClick}/>ouverts</label>).firstElementChild as HTMLInputElement;
		this.closed = critHead.appendChild(<label class="opt"><input type="checkbox" onclick={this.onClick}/>clos</label>).firstElementChild as HTMLInputElement;
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		if (xml.hasAttribute("uiIncludeOpen"))
			this.opened.checked = true;
		if (xml.hasAttribute("uiIncludeClosed"))
			this.closed.checked = true;
		return this;
	}

	protected onClick(this: HTMLInputElement): void {
		const me = DOMSH.findHost<ItemCritComment>(this);
		if (!me.opened.checked && !me.closed.checked) {
			//Les deux ne peuvent être décochés à la fois, on récative celui qui a été décoché.
			if (this === me.opened) {
				me.closed.checked = true;
			} else {
				me.opened.checked = true;
			}
		}
		me.onChange();
	}

	buildCrit(): ISearchCrit | undefined {
		return new SearchItemComment(this.withOpenComments, this.withClosedComments);
	}

	/**
	 * Critères UI :
	 *  - uiIncludeOpen
	 *  - uiIncludeClosed
	 */
	buildUiXmlCrit(): Element | undefined {
		const crit: Element = super.buildUiXmlCrit();
		if (crit && this.withOpenComments) crit.setAttribute("uiIncludeOpen", null);
		if (crit && this.withClosedComments) crit.setAttribute("uiIncludeClosed", null);
		return crit;
	}
}


customElements.define("wsp-itemcrit-comment", ItemCritComment);

REG.reg.registerSvc("wsp-itemcrit-comment", 1, ItemCritComment.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-comment", 1, "wsp-itemcrit-comment");


/**
 * Cycle de vie de l'item
 *    <wsp-itemcrit-lifecycle/>
 */
export class ItemCritLifeCycle extends UiCritBase {

	static AREA = new UiCritArea("wsp-itemcrit-lifecycle")
		.setLabel((ctx) => ctx.reg.env.wsp.wspMetaUi.getLcName())
		.setVisible((ctx) => (ctx.reg.env.wsp.hasFeature("liveCycle") && ctx.reg.env.wsp.wspMetaUi.getLcStates() !== null) ? true : false)
		.setCritSgn("lifecycle").setGroup("item").setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {

			// Cycles de vie
			const lcStates = xml.getAttribute("lcStates") || "";
			const lcStatesArr = lcStates.split(" ");
			const lcStatesLabels: string[] = [];
			lcStatesArr.forEach((stateCode) => {
				const state = ctx.reg.env.wsp.wspMetaUi.getLcState(stateCode != LC_STATE_DEFAULT_KEY ? stateCode : "");
				if (state && state.name)
					lcStatesLabels.push(state.name)
				else if (state && state.code == "")
					lcStatesLabels.push(LC_STATE_DEFAULT_NAME)
				else
					lcStatesLabels.push(stateCode);//LC state inconnu
			})
			let strCplts = [];
			if (xml.getAttribute("uiCurrentMode"))
				strCplts.push(<span>période donnée</span>)
			const lcBys = xml.getAttribute("lcBys");
			if (lcBys) {
				let accounts = lcBys.split(" ");
				const usersListVal = <span>affecté par '{accounts.join(", ")}'</span>;
				strCplts.push(usersListVal)
				ctx.reg.env.universe.useUsers.getUserSet(accounts).then(users => {
					if (users) {
						accounts = [];
						const names: string[] = [];
						users.forEach(user => {
							accounts.push(USER.getPrimaryName(user));
							names.push(USER.getLongName(user));
						});
						usersListVal.textContent = "affecté par '" + accounts.join(", ") + "'";//FIXME L10n
						usersListVal.setAttribute("title", names.join(", "));
					}
				});
			}
			const lcName = ctx.reg.env.wsp.wspMetaUi.getLcName();
			const label = lcStatesLabels.length > 1 ? `États du ${lcName} :` : `État du ${lcName} :`;
			const result: HTMLSpanElement = <span class="crit">{label} <span class="critVal">{lcStatesLabels.join(", ")}</span></span>;

			if (strCplts.length > 0) {
				result.appendChild(document.createTextNode(" ("));
				strCplts.forEach(((elt, pos) => {
					if (pos > 0 && pos < strCplts.length) result.appendChild(document.createTextNode(", "));
					result.appendChild(elt)
				}));
				result.appendChild(document.createTextNode(")"));
			}
			return result;
		});

	protected _lcElt: HTMLSelectElement;

	protected _dateElt: InputPeriod;

	protected _userElt: InputUserPanel<any>;

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;
		this.reg.installSkin("wsp-itemcrit-lifecycle", sr);

		this._lcElt = <select onchange={this.onChange} class="lcSelect" multiple="true"/> as HTMLSelectElement;
		this.reg.env.wsp.wspMetaUi.getLcStates().forEach((tr) => {
			let opt = this._lcElt.appendChild(<option value={tr.code || LC_STATE_DEFAULT_KEY}>{tr.name || LC_STATE_DEFAULT_NAME}</option>);
			opt.style.color = tr.color || "var(--color)";
			if (tr.iconUrl) opt.style.backgroundImage = `url("${tr.iconUrl}")`;
			if (tr.code == "") DOM.setAttrBool(opt, "selected", true);
		});

		this._dateElt = new InputPeriod().initialize();
		this._dateElt.title = "Période pendant laquelle l'état du cycle de vie a été affecté";
		this._dateElt.addEventListener("change", this.onChange);
		this._dateElt.addEventListener("input", this.onChange);

		this._userElt = new InputUserPanel().initialize({
			name: "choiceUser",
			reg: this.reg,
			emptySelectionMsg: "Sélectionner un utilisateur...",
			userCard: "multi",
			usersGridInit: {
				usersSrv: this.reg.env.universe.useUsers,
				grid: {selType: "mono"},
				filterType: EUserType.user,
				filterTypeInputVisibility: false,
			},
		} as OInputUserInit<any>) as InputUserPanel<any>;
		this._userElt.addEventListener("change", this.onChange);
		this._userElt.title = "État affecté par l'un des utilisateurs";

		sr.appendChild(<div class="critHead">
			<span class="critTitle">{this.reg.env.wsp.wspMetaUi.getLcName()}</span>
			{this._lcElt}
			{this.insertAlternativesBtn(init)}
		</div>);
		sr.appendChild(<div class="h">
			<span>défini</span>
			{this._dateElt}
			<span>par</span>
			{this._userElt}
		</div>);
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		// LC
		this._lcElt.selectedIndex = -1;
		const lcStates = xml.getAttribute("lcStates") || "";
		const lcStatesArr = lcStates.split(" ");
		Array.from(this._lcElt.options).forEach(opt => {
			opt.selected = lcStatesArr.includes(opt.value)
		})
		// date
		this._dateElt.reset(xml.getAttribute("uiCurrentMode"), xml.hasAttribute("uiCurrentLess") ? Number.parseInt(xml.getAttribute("uiCurrentLess")) : null, xml.hasAttribute("uiCurrentMore") ? Number.parseInt(xml.getAttribute("uiCurrentMore")) : null);
		// by
		const lcBys = xml.getAttribute("lcBys");
		if (lcBys)
			this._userElt.value = lcBys.split(" ")

		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		let crit = this._dateElt.isSpecified() ? SearchLifeCycleStates.buildFromInputPeriod(this._dateElt) : new SearchLifeCycleStates();
		crit.lcStates = [];
		Array.from(this._lcElt.selectedOptions).forEach(opt => crit.lcStates.push(opt.value))
		crit.lcBys = this._userElt.value;
		return crit;
	}

	buildUiXmlCrit(): Element | undefined {
		const crit: Element = super.buildUiXmlCrit();
		if (crit && this._dateElt.isSpecified()) {
			crit.setAttribute("uiCurrentMode", this._dateElt.currentMode.getId());
			// Valeurs brutes (sans les regles d'exclusion/noemalisation qui sont fournies par le "currentMode")
			if (this._dateElt.date1.valueAsNumber) crit.setAttribute("uiCurrentLess", this._dateElt.date1.valueAsNumber.toString());
			if (this._dateElt.date2.valueAsNumber) crit.setAttribute("uiCurrentMore", this._dateElt.date2.valueAsNumber.toString());
		}
		return crit;
	}

}

customElements.define("wsp-itemcrit-lifecycle", ItemCritLifeCycle);
REG.reg.registerSkin('wsp-itemcrit-lifecycle', 1, /* language=CSS */ `

	c-input-period {
		margin-inline-start: 1em;
		margin-inline-end: 1em;
	}

	c-input-users-panel {
		margin-inline-start: 1em;
		min-height: 1.5rem;
	}

	.h {
		margin-top: .5em;
	}

	.lcSelect {
		flex: 1;
		resize: vertical;
		height: 10rem;
	}

	.lcSelect > option {
		/*background-image: url("affecteeDynamiquement");*/
		background-repeat: no-repeat;
		background-size: 1rem auto;
		background-position-y: center;
		background-position-x: 1px;
		min-width: 3rem;
		padding-inline-start: 1.3rem;
	}
`);

REG.reg.registerSvc("wsp-itemcrit-lifecycle", 1, ItemCritLifeCycle.AREA);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-lifecycle", 1, "wsp-itemcrit-lifecycle");

/**
 * Responsabilités de l'item
 *    <wsp-itemcrit-respsonsabilities/>
 */
export abstract class ItemCritRespsonsabilities extends UiCritBase {

	static AREA_item = ItemCritRespsonsabilities.makeArea('item', 'wsp-itemcrit-respsonsabilities');
	static AREA_task = ItemCritRespsonsabilities.makeArea('task', 'wsp-taskcrit-respsonsabilities');

	static makeArea(target: 'task' | 'item', tag: string): UiCritArea {
		return new UiCritArea(tag).setLabel("Responsabilités")
			.setVisible((ctx) => (ctx.reg.env.wsp.hasFeature("resp") && ctx.reg.env.wsp.wspMetaUi.hasResps) ? true : false)
			.setCritSgn("respsonsabilities").setGroup(target).setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {

				// Resps
				const modelResps = ctx.reg.env.wsp.wspMetaUi.listResps(target);
				const resps = xml.getAttribute("responsibilities") || "";
				const respsArr = resps.split(" ");
				const respsLabels: string[] = [];
				respsArr.forEach((resp) => {
					const currentResp = modelResps.find((entry) => entry.code === resp);
					respsLabels.push(currentResp ? currentResp.name : resp);
				})

				// users
				let usersListVal: HTMLElement;
				const users = xml.getAttribute("users");
				if (users) {
					const accounts = users.split(" ");
					const usersObj = <span/>;
					accounts.forEach((account, pos) => {
						if (pos > 0)
							usersObj.appendChild(<span> ou </span>);
						usersObj.appendChild(<UserRef class="inline list" î={{reg: ctx.reg, nickOrAccount: account, withIcon: false} as OUserRefInit}/>)
					});
					usersListVal = respsLabels.length > 1 ?
						<span>attribuées à '{usersObj}'</span> :
						<span>attribuée à '{usersObj}'</span>;//FIXME L10n
					if (xml.getAttribute("expandUsers"))
						usersListVal.appendChild(<span> (étendu aux membres/groupes)</span>);
				}

				if (respsLabels.length > 1)
					return <span class="crit">Responsabilités '<span class="critVal">{respsLabels.join(" ou ")}</span>' {usersListVal}</span>;
				else
					return <span class="crit">Responsabilité '<span class="critVal">{respsLabels}</span>' {usersListVal}</span>;
			});
	}

	protected target: 'task' | 'item';

	protected _respElt: HTMLSelectElement;

	protected _userElt: InputUserPanel<any>;

	protected _toGroupsElt: HTMLInputElement;

	protected _toMembersElt: HTMLInputElement;

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;
		this.reg.installSkin("wsp-crit-respsonsabilities", sr);

		const withGroups = this.reg.env.universe.useUsers.hasAspect(EUserAspects.groupable);

		this._respElt = <select onchange={this.onChange} class="respSelect" multiple="true"/> as HTMLSelectElement;
		this.reg.env.wsp.wspMetaUi.listResps(this.target).forEach((resp) => {
			let opt = this._respElt.appendChild(<option value={resp.code}>{resp.name}</option>);
			if (resp.desc) opt.title = resp.desc;
		});

		this._userElt = new InputUserPanel().initialize({
			name: "choiceUser",
			reg: this.reg,
			emptySelectionMsg: withGroups ? "Utilisateurs/groupes..." : "Utilisateurs...",
			userCard: "multi",
			usersGridInit: {
				usersSrv: this.reg.env.universe.useUsers,
				filterTypeInputVisibility: true,
				filterType: null,
			},
		} as OInputUserInit<any>) as InputUserPanel<any>;
		this._userElt.addEventListener("change", this.onChange);
		this._userElt.title = withGroups ?
			"Au mois un utilisateur / groupe est concerné par au moins une responsabilité sélectionnée." :
			"Au mois un utilisateur est concerné par au moins une responsabilité sélectionnée.";

		let critGroups;
		if (withGroups) {
			this._toGroupsElt = <input type="checkbox" onclick={this.onChange}/> as HTMLInputElement;
			this._toMembersElt = <input type="checkbox" onclick={this.onChange}/> as HTMLInputElement;
			critGroups = <div class="h">
				<label class="opt"
							 title={this.target == "item" ? "Inclure les items associés aux groupes auxquels les utilisateurs sélectionnés appartiennent" : "Inclure les tâches associées aux groupes auxquels les utilisateurs sélectionnés appartiennent"}>{this._toGroupsElt}+ groupes</label>
				<label class="opt" title={this.target == "item" ? "Inclure les items associés aux membres des groupes sélectionnés" : "Inclure les tâches associées aux membres des groupes sélectionnés"}>{this._toMembersElt}+ membres</label>
			</div>;
		}

		const critHead = sr.appendChild(<div class="critHead">
			<span class="critTitle">Responsabilités</span>
			{this._respElt}
			{this.insertAlternativesBtn(init)}
		</div>);
		sr.appendChild(
			<div class="h">
				<span>attribuées à</span>
				<div class="v usersBox">
					{this._userElt}
					{critGroups}
				</div>
			</div>
		);
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		// - resp
		this._respElt.selectedIndex = -1;
		const resps = xml.getAttribute("responsibilities") || "";
		const respsArr = resps.split(" ");
		for (const opt of this._respElt.options) {
			opt.selected = respsArr.includes(opt.value)
		}
		// - users
		const users = xml.getAttribute("users");
		if (users)
			this._userElt.value = users.split(" ")
		// - options
		const expandUsers = xml.getAttribute("expandUsers");
		if (this._toGroupsElt)
			this._toGroupsElt.checked = expandUsers?.includes('toGroups');
		if (this._toMembersElt)
			this._toMembersElt.checked = expandUsers?.includes('toMembers');
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		const resps = [];
		for (const opt of this._respElt.selectedOptions) {
			resps.push(opt.value)
		}
		let crit = new SearchResponsibilities(resps, this._userElt.value, this._toMembersElt?.checked, this._toGroupsElt?.checked);
		return crit;
	}

}

export class ItemCritRespsonsabilities_item extends ItemCritRespsonsabilities {
	protected target: 'task' | 'item' = "item";
}

customElements.define("wsp-itemcrit-respsonsabilities", ItemCritRespsonsabilities_item);
REG.reg.registerSkin('wsp-crit-respsonsabilities', 1, /* language=CSS */ `
	.respSelect {
		flex: 1;
	}

	.h {
		margin-top: .5em;
	}

	.usersBox {
		flex: 1
	}

	c-input-users-panel {
		margin-inline-start: 1em;
		flex: 1
	}
`);

REG.reg.registerSvc("wsp-itemcrit-respsonsabilities", 1, ItemCritRespsonsabilities.AREA_item);
REG.reg.addSvcToList("wsp.crit.items", "wsp-itemcrit-respsonsabilities", 1, "wsp-itemcrit-respsonsabilities");